export const PARAMETERS = 'parameters'; //DIST026

export const DIST026_TREATMENT_KEY = 'dist-026';
export const DIST026_GROUP_PARAMETER_KEY = 'group';
export const DIST026_STATUS_PARAMETER_KEY = 'status';
export const DIST026_IS_ACTIVE_KEY = 'isActive';
export let DIST026_GROUP_PARAMETER_OPTIONS;

(function (DIST026_GROUP_PARAMETER_OPTIONS) {
  DIST026_GROUP_PARAMETER_OPTIONS["control"] = "control";
  DIST026_GROUP_PARAMETER_OPTIONS["variant"] = "variant";
})(DIST026_GROUP_PARAMETER_OPTIONS || (DIST026_GROUP_PARAMETER_OPTIONS = {}));